import { useSession } from "next-auth/react";
import { useEffect } from "react";

export function useAutoSessionRefresh() {
  const { update } = useSession();

  useEffect(() => {
    const interval = setInterval(
      () => {
        update();
      },
      1000 * 60 * 60 * 30,
    );

    return () => clearInterval(interval);
  }, [update]);
}
